import { FC, type ReactNode } from "react";

/**
 * 公共选择弹窗壳
 * 结构：eyebrow(可选) + 标题/副标题 + 关闭 | 内容区 | 底部（左侧提示 + 取消/确认）
 */
export const PickerModal: FC<{
  eyebrow?: string;
  title: string;
  subtitle?: string;
  /** 弹窗最大宽度，默认 720 */
  width?: number;
  onClose: () => void;
  /** 底部左侧提示文字（如「已选：xx」「已选择 1 / 1」） */
  footerLeft?: ReactNode;
  cancelText?: string;
  confirmText: string;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  children: ReactNode;
}> = ({
  eyebrow,
  title,
  subtitle,
  width,
  onClose,
  footerLeft,
  cancelText = "取消",
  confirmText,
  confirmDisabled,
  onConfirm,
  children,
}) => (
  <div className="adh-modal-backdrop" onClick={onClose}>
    <div
      className="adh-modal adh-picker-modal"
      style={width ? { maxWidth: width } : undefined}
      onClick={(e) => e.stopPropagation()}
    >
      <header>
        {eyebrow && <span className="adh-eyebrow">{eyebrow}</span>}
        <div className="adh-picker-header-text">
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
        <button type="button" className="adh-modal-close" onClick={onClose}>×</button>
      </header>
      <div className="adh-picker-body">{children}</div>
      <footer>
        <span className="adh-picker-footer-left">{footerLeft}</span>
        <div className="adh-picker-footer-actions">
          <button className="adh-secondary-btn" type="button" onClick={onClose}>{cancelText}</button>
          <button className="adh-primary-btn" type="button" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmText}
          </button>
        </div>
      </footer>
    </div>
  </div>
);

/** 公共页签（下划线式：公共 xx / 我的 xx） */
export const PickerTabs: FC<{
  items: { key: string; label: string }[];
  value: string;
  onChange: (key: string) => void;
}> = ({ items, value, onChange }) => (
  <div className="adh-picker-tabs" role="tablist">
    {items.map((it) => (
      <button
        key={it.key}
        type="button"
        role="tab"
        aria-selected={value === it.key}
        className={value === it.key ? "active" : ""}
        onClick={() => onChange(it.key)}
      >
        {it.label}
      </button>
    ))}
  </div>
);
